import React from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Services from "./components/Services";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import WhyUs from "./components/WhyUs";

const App = () => {
  return (
    <div className="bg-primary text-white">
      <Navbar />
      <Hero />
      <About />
      <Services />
      <Contact />
      <WhyUs />
      <Footer />
    </div>
  );
};

export default App;
